<template>
  <div class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <section>
          <v-card
            flat
            class="mt-2"
            color="transparent">
            <div class="d-flex align-center px-3">
              <div class="d-flex align-center">
                <v-avatar tile size="22">
                  <v-img
                    contain
                    alt="cashflow"
                    :src="require('@/assets/image/grip_menu.png')">
                    <template v-slot:placeholder>
                      <v-row class="fill-height" align="center" justify="center">
                        <v-progress-circular size="20" indeterminate :color="set_color"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <span class="fs-16 black--text ml-2" style="font-weight: 600;">
                  Laporan Arus Kas
                </span>
              </div>

              <v-spacer/>
            </div>
          </v-card>

          <div class="d-flex mt-3 px-4 cf-filters">
            <div class="d-flex align-center flex-wrap">
              <div>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      filled
                      rounded
                      dense
                      hide-details
                      readonly
                      :color="set_color"
                      placeholder="Pilih Rentang Tanggal"
                      :value="dateRangeText"
                      prepend-inner-icon="mdi-calendar-range"
                      class="fs-12 cf-filter-field"
                      style="border-radius: 6px; width: 230px; min-width: 230px; max-width: 230px;"
                      v-bind="attrs"
                      v-on="on">
                    </v-text-field>
                  </template>

                  <v-date-picker
                    v-model="filter.dateRange"
                    range
                    no-title
                    locale="id-ID"
                    :color="set_color"
                    @change="onDateRangeChange">
                  </v-date-picker>
                </v-menu>
              </div>

              <div class="ml-3">
                <v-select
                  filled
                  rounded
                  dense
                  hide-details
                  :color="set_color"
                  :item-color="set_color"
                  placeholder="Posisi"
                  :items="positions"
                  item-text="name"
                  item-value="id"
                  v-model="filter.position"
                  class="fs-12 cf-filter-field"
                  style="border-radius: 6px; width: 120px; min-width: 120px; max-width: 120px;"
                  @change="fetch">
                </v-select>
              </div>

              <div class="ml-3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="exportsPdf"
                      :loading="process.export"
                      elevation="0"
                      dark
                      min-height="30"
                      small
                      min-width="30"
                      color="#b40c1d"
                      class="text-capitalize px-0 white--text"
                      style="border-radius: 6px;"
                      v-bind="attrs"
                      v-on="on">
                      <v-icon size="24">mdi-file-pdf-box</v-icon>
                    </v-btn>
                  </template>
                  <span>Export Pdf</span>
                </v-tooltip>
              </div>

              <div class="ml-3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="exportsExcel"
                      :loading="process.export_excel"
                      elevation="0"
                      dark
                      min-height="30"
                      small
                      min-width="30"
                      color="#097640"
                      class="text-capitalize px-0 white--text"
                      style="border-radius: 6px;"
                      v-bind="attrs"
                      v-on="on">
                      <v-icon size="24">mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>Export Excel</span>
                </v-tooltip>
              </div>
            </div>
          </div>

          <v-row class="pa-4 py-0 mt-3">
            <v-col cols="12" class="py-0">
              <v-card
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load"
                  class="pb-0 my-4"
                  style="height: calc(100vh - 250px); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center" style="width: 320px;">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>
                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>

                <v-card-text v-else class="pa-4">
                  <div v-if="message.error" class="error--text fs-12 mb-3">
                    {{ message.error }}
                  </div>

                  <cashflow-report-table
                    :rekapitulasi="rekapitulasi"
                    :summary="reportSummary"
                    :color="set_color">
                  </cashflow-report-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment";
  import "moment/locale/id";
  import { getReportData, getRekapitulasi } from "@/utils/cashflowReport";
  import CashflowReportTable from "@/components/cashflow/CashflowReportTable.vue";

  export default {
    components: {
      CashflowReportTable
    },
    data () {
      return {
        dialog: {
          snackbar: false
        },

        dateMenu: false,

        filter: {
          dateRange: [
            moment().startOf('month').format('YYYY-MM-DD'),
            moment().endOf('month').format('YYYY-MM-DD')
          ],
          position: 'public'
        },

        positions: [
          { id: 'internal', name: 'Internal' },
          { id: 'public', name: 'Public' }
        ],

        list: null,

        process: {
          load: false,
          export: false,
          export_excel: false
        },

        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      set_color () {
        return this.$store.state.color
      },
      sortedDateRange () {
        const range = this.filter.dateRange || []
        if (range.length < 2) return range

        return [...range].sort((a, b) => moment(a).diff(moment(b)))
      },
      dateRangeText () {
        const [start, end] = this.sortedDateRange

        if (!start) return ''
        if (!end || start === end) return moment(start).format('DD MMM YYYY')

        return `${moment(start).format('DD MMM YYYY')} - ${moment(end).format('DD MMM YYYY')}`
      },
      rekapitulasi () {
        return getRekapitulasi(this.list)
      },
      reportSummary () {
        const data = getReportData(this.list)
        if (!data) return null

        return {
          total_uang_masuk: data.total_uang_masuk,
          total_uang_keluar: data.total_uang_keluar,
          net_cashflow: data.net_cashflow
        }
      },
      queryParams () {
        const [start, end] = this.sortedDateRange

        return {
          start_date: start,
          end_date: end || start,
          position: this.filter.position
        }
      }
    },
    created () {
      if (String(this.$store.state.user.cat_id) === '21') {
        this.positions = [{ id: 'public', name: 'Public' }]
        this.filter.position = 'public'
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      onDateRangeChange (range) {
        if (range && range.length === 2) {
          this.dateMenu = false
          this.fetch()
        }
      },

      async fetch () {
        this.process.load = true
        this.message.error = ''
        this.list = null

        await get(`cashflow/data`, {
          params: this.queryParams
        }).then(response => {
          let res = response.data

          this.process.load = false
          this.list = res

          console.log('cashflow/data response:', res)

          if (res.status !== 200) {
            this.message.error = res.message || 'Gagal memuat data'
          }
        }).catch(err => {
          this.process.load = false
          this.message.error = (err && err.message) || 'Gagal memuat data'
          this.list = { error: this.message.error }
          console.error('cashflow/data error:', err)
        })
      },

      async exportsPdf () {
        this.message.error = ''
        this.process.export = true

        await axios({
          url: `${process.env.VUE_APP_API_URL}/cashflow/data/export_pdf`,
          method: 'GET',
          responseType: 'blob',
          params: this.queryParams,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false

          let disposition = res.headers['content-disposition']
          let filename = 'cashflow.pdf'

          if (disposition) {
            let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            let matches = filenameRegex.exec(disposition)
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '')
            }
          }

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
          }
        }).catch(err => {
          this.process.export = false
          this.message.error = (err && err.message) || 'Gagal export pdf'
        })
      },

      async exportsExcel () {
        this.message.error = ''
        this.process.export_excel = true

        await axios({
          url: `${process.env.VUE_APP_API_URL}/cashflow/data/export_excel`,
          method: 'GET',
          responseType: 'blob',
          params: this.queryParams,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export_excel = false

          let disposition = res.headers['content-disposition']
          let filename = 'cashflow.xlsx'

          if (disposition) {
            let fileName = disposition.split('filename=')[1]
            if (fileName) {
              filename = fileName.replace(/['"]/g, '')
            }
          }

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport Excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
          }
        }).catch(err => {
          this.process.export_excel = false
          this.message.error = (err && err.message) || 'Gagal export excel'
        })
      }
    }
  }
</script>

<style scoped>
  /* Deep selectors: scoped CSS cannot style Vuetify internals without >>> */
  .cf-filters >>> .v-text-field--rounded > .v-input__control > .v-input__slot {
    padding: 0 15px !important;
  }

  .cf-filters >>> .v-text-field--filled.v-input--dense > .v-input__control > .v-input__slot,
  .cf-filters >>> .v-text-field--outlined.v-input--dense > .v-input__control > .v-input__slot {
    min-height: 30px !important;
  }

  .cf-filters >>> .v-text-field--enclosed.v-input--dense .v-input__append-inner,
  .cf-filters >>> .v-text-field--enclosed.v-input--dense .v-input__append-outer {
    margin-top: 4px !important;
  }
</style>